export type HiddenTimingItem = {
    time: number;
    hidden: boolean;
};

export type PageVisibility = "hidden" | "mixed" | "visible";

const timings: Array<HiddenTimingItem> = [];
let wasHiddenFlag: boolean;
let setupFlag = false;

function isPageHidden() {
    if ("visibilityState" in document) {
        return document.visibilityState === "hidden";
    } else {
        // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
        return document.hidden;
    }
}

const SIZE = 50;
let insertIndex = 0;

function pushHidden(isPageHiddenFlag: boolean, time?: number) {
    timings[insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    insertIndex = (insertIndex + 1) % SIZE;
    wasHiddenFlag = isPageHiddenFlag;
}

function handleChange() {
    const isPageHiddenFlag = isPageHidden();
    if (isPageHiddenFlag) {
        if (!wasHiddenFlag) {
            pushHidden(isPageHiddenFlag);
        }
        wasHiddenFlag = true;
    } else {
        if (wasHiddenFlag) {
            pushHidden(isPageHiddenFlag);
        }
        wasHiddenFlag = false;
    }
}

function setup() {
    window.addEventListener("pageshow", handleChange);

    window.addEventListener("pagehide", handleChange);

    document.addEventListener("visibilitychange", handleChange);
}

export function setupHiddenTimingCapture() {
    if (!setupFlag) {
        const isPageHiddenFlag = isPageHidden();
        pushHidden(isPageHiddenFlag, 0);
        setup();
        setupFlag = true;
    }
}

export function getPageVisibilityState(
    start: number,
    end: number
): PageVisibility {
    // Desirable default value is visible
    if (timings.length === 0) {
        return "visible";
    }

    const currentSize = timings.length;
    let hiddenState: PageVisibility = "mixed";

    let startIdx = insertIndex;
    let endIdx = insertIndex;

    // currentSize is capped at SIZE.
    for (let i = 0; i < currentSize; i++) {
        const tmpIdx = (insertIndex + i) % currentSize;
        const time = timings[tmpIdx]?.time;
        if (time) {
            if (time <= end) {
                endIdx = tmpIdx;
                if (time <= start) startIdx = tmpIdx;
            }
        }
    }

    if (endIdx - startIdx === 0) {
        const hidden = timings[startIdx]?.hidden;
        if (hidden) {
            hiddenState = "hidden";
        } else {
            hiddenState = "visible";
        }
    }
    return hiddenState;
}
